import React, {PropTypes} from 'react';
import { PageHeader, Grid, Image, Thumbnail } from 'react-bootstrap';
import { Link } from 'react-router-dom'
// LOCAL
// SHARED
import PotentialCredits from '../subscriptions/PotentialCredits';
import Card, { CardHeader } from '../core/Card'
import { CrownIcon, ReportIcon } from '../core/icons'
import {Doughnut, Line} from 'react-chartjs'
import { Progress, Icon, Row, Col, Modal } from 'antd';
import './Home.css'
import { DatePicker } from 'antd';
import numeral from 'numeral';
import { connect } from 'react-redux'
import {updateRange} from './actions'
import EmptyState from '../core/components/EmptyState'
import { CarIcon } from '../core/icons'
import moment from 'moment'
import Share from './Share'
import { TextAppBanner, AppBanner } from './'

const { MonthPicker, RangePicker } = DatePicker;

// TODO this gets defined in action or reducer?

const mapStateToProps = (state) => {

  const {user} = state.models

  const {kms_enabled} = user

  const totals_names = ["total_revenue", "total_expenses" , "total_trips_deductions",
  "total_standard_method_expenses", "total_standard_method_revenue" , "total_miles",
   "total_uncategorized_miles" , "total_business_miles" , "total_personal_miles" , "total_medical_miles",
   "total_charity_miles" , "total_moving_miles" , "total_other_miles" , "total_kms" , "total_uncategorized_kms",
    "total_business_kms" , "total_personal_kms" , "total_medical_kms" , "total_charity_kms" , "total_moving_kms" , "total_other_kms"]

  const mType = kms_enabled ? 'kms' : 'miles'
  return {
    isFetching: user.isFetching,
    kms_enabled,
    // transactions chart:
    revenue: user.total_revenue || 0,
    expenses: Math.abs(user.total_expenses) || 0,
    // trips chart:
    unclassified: user['total_uncategorized_'+mType],
    work: user['total_business_'+mType],
    other: user['total_other_'+mType],
    personal: user['total_personal_'+mType],
    range: [moment().startOf('year'), moment()],
    chartData: [
      {
        value: user['total_business_'+mType],
        color: "#31B59F",
        highlight: "#31B59F",
        label: "Work"
      },
      {
        value: user['total_personal_'+mType],
        color: "#2496C5",
        highlight: "#2496C5",
        label: "Personal"
      },
      {
        value: user['total_other_'+mType],
        label: "Other",
        color: "#E47E30"
      },
      {
        value: user['total_uncategorized_'+mType],
        label: "Unclassified",
        color: "#94A5B5"
      }
    ]
  }
}
const rangePickerRanges = {
  Today: [moment(), moment()],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  'This Year': [moment().startOf('year'), moment().endOf('year')],
  'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
}
const Trips = connect(mapStateToProps, {updateRange})( ({
  kms_enabled, chartData, unclassified, work, other, personal, range, updateRange,
  isFetching
}) =>
  <Card className="Trips" showLoadingIcon={isFetching}>
    <CardHeader
      title="Trips"
      customActionComponent={
        <span>
          <RangePicker
            ranges={rangePickerRanges}
            allowClear={false} defaultValue={range} onChange={updateRange}
            format={'MM-DD-YYYY'}
          />
        </span>
      }
    />

    <div className="content">
      <div className="legend">
        <div className="flex-grid">
          <div className="col" style={{color: "#31b59f"}}><h2>Work</h2><span>{numeral(work).format('(0,0)')} {kms_enabled?'km':'mi'}</span></div>
          <div className="col" style={{color: "#2496C5"}}><h2>Personal</h2><span>{numeral(personal).format('(0,0)')} {kms_enabled?'km':'mi'}</span></div>
        </div>
        <div className="flex-grid">
          <div className="col" style={{color: "#E47E30"}}><h2>Other</h2><span>{numeral(other).format('(0,0)')} {kms_enabled?'km':'mi'}</span></div>
          <div className="col" style={{color: "#94A5B5"}}><h2>Unclassified</h2><span>{numeral(unclassified).format('(0,0)')} {kms_enabled?'km':'mi'}</span></div>
        </div>
      </div>
      {(chartData.reduce((a,c)=>a+parseFloat(c.value), 0) >0)
        ? <Doughnut data={chartData} height="185"/>
        : <Icon type="pie-chart" />
      }
    </div>


    {/*<div className="content">Soon this chart will be full of miles! Come back after a drive or add a trip.</div>*/}

  </Card>
)

const Transactions = connect(mapStateToProps, {updateRange})( ({
  revenue, expenses, range, updateRange, isFetching
}) =>
  <Card className="Transactions" showLoadingIcon={isFetching}>
    <CardHeader
      title="Transactions"
      customActionComponent={
        <span>
          <RangePicker
            ranges={rangePickerRanges}
            format={'MM-DD-YYYY'}
            allowClear={false} defaultValue={range} onChange={updateRange}/>
          {/*<Link to="/transactions">See More</Link>*/}
        </span>
      }
    />
    <div className="content">

    {(revenue == 0 && expenses == 0) ? (
      <Row type="flex" justify="space-between" align="middle">
        <Col span={17}>
          <Row className="revenue">
            <h2>Revenue</h2>
            <span>${numeral(revenue).format('(0,0.00)')}</span>
          </Row>
          <Row className="expenses">
            <h2>Expenses</h2>
            <span>${numeral(expenses).format('(0,0.00)')}</span>
          </Row>
        </Col>
        <Col span={7}>
          <Icon type="area-chart" />
        </Col>
      </Row>

    ) : (
      <span>
        <Row className="revenue" type="flex" justify="space-between" align="middle">
          <Col xs={24} md={6}>
            <h2>Revenue</h2>
            <span>${numeral(revenue).format('(0,0.00)')}</span>
          </Col>
          <Col xs={24} md={18}>
            <Progress percent={(revenue / Math.max(revenue, expenses))*100} strokeWidth={25} showInfo={false}/>
          </Col>
        </Row>
        <Row className="expenses" type="flex" justify="space-between" align="middle">
          <Col xs={24} md={6}>
            <h2>Expenses</h2>
            <span>${numeral(expenses).format('(0,0.00)')}</span>
          </Col>
          <Col xs={24} md={18}>
            <Progress percent={(expenses / Math.max(revenue, expenses))*100} strokeWidth={25} showInfo={false}/>
          </Col>
        </Row>
      </span>
    )}


    </div>
  </Card>
)

const MainContentHome = ({
  hasMobileApp=false, productIdentifier, isPremium, trial_days_remaining
}) =>
  <div className="MainContentHome">

    <Row gutter={20}>
      <Col sm={8}>
        <Card style={{height:200}}>
          <Link to="/data-exports">
            <CardHeader title="Data Exports" />
            <div className="Action">
              <ReportIcon width='50' height='50'/>
              <h3>Create Data Export</h3>
            </div>
          </Link>
        </Card>
      </Col>

      <Col sm={8}>
        <Card style={{height:200}}>
          <Link to="/premium">
            <CardHeader title="Premium" />
            <div className="Action">
              <CrownIcon width='50' height='50'/>

              {(trial_days_remaining && trial_days_remaining >= 0)
                ? <h3>{trial_days_remaining} Premium Trial Days Left</h3>
                : (isPremium)
                ? <h3>Manage Subscription</h3>
                : <h3>Upgrade for Unlimited Trips</h3>
              }

            </div>
          </Link>
        </Card>
      </Col>

      <Col sm={8}>
        <Share style={{height:200}}/>
      </Col>
    </Row>

    <Row>
      <Col sm={24}>
        <Trips/>
      </Col>
    </Row>

    <Row>
      <Col sm={24}>
        <Transactions/>
      </Col>
    </Row>

    { !hasMobileApp &&
      <Row gutter={20}>
        <Col sm={12}>
          <AppBanner/>
        </Col>

        <Col sm={12}>
          <TextAppBanner/>
        </Col>
      </Row>
    }

    <Row>
      <Col sm={24}>
        <PotentialCredits productIdentifier={productIdentifier} wrapInCard/>
      </Col>
    </Row>


  </div>

export default MainContentHome



// WEBPACK FOOTER //
// ./src/home/MainContentHome.js